var _g, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _path22, _g3, _g4, _g5, _g6, _g7, _g8, _path23, _g9, _g10, _path24, _path25, _path26, _g11, _g12, _g13, _g14, _path27, _path28, _path29, _g15, _g16, _path30, _path31, _path32, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTippinghand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint0_linear_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint1_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint2_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint3_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint4_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint5_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint6_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint7_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint8_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7527 15.0784C22.0268 14.5171 22.1704 13.8906 22.1704 13.238C22.1704 12.6353 22.0464 12.0697 21.824 11.5542H21.8309C21.7272 11.3208 21.6105 11.1003 21.4682 10.8926L21.4656 10.8886C21.0218 10.2098 20.7869 9.41365 20.7869 8.60441V8.59136C20.7869 6.24194 18.8812 4.3363 16.5318 4.3363C16.2969 4.3363 16.075 4.23189 15.9445 4.0361C15.1744 2.96581 13.9082 2.26099 12.4855 2.26099C11.0628 2.26099 9.79669 2.96581 9.0266 4.0361C8.89608 4.21883 8.67419 4.3363 8.43925 4.3363C8.40258 4.3363 8.36602 4.33677 8.32958 4.33769C6.03082 4.39589 4.18419 6.27861 4.18419 8.59136V8.60441C4.18419 9.41365 3.94925 10.2098 3.50547 10.8886L3.50251 10.8933C3.06061 11.571 2.80078 12.3655 2.80078 13.238C2.80078 13.9036 2.95741 14.5171 3.21846 15.0784C3.30982 15.2611 3.30982 15.483 3.21846 15.6657C2.95741 16.2139 2.80078 16.8274 2.80078 17.48C2.80078 19.7772 4.65421 21.6306 6.95142 21.6306H18.0198C20.317 21.6306 22.1704 19.7772 22.1704 17.48C22.1704 16.8274 22.0138 16.2139 21.7527 15.6657C21.6614 15.483 21.6614 15.2611 21.7527 15.0784ZM5.94021 11.6316H5.92433L7.47035 14.6697C7.62937 18.2842 9.03999 14.6697 12.4855 14.6697C15.9309 14.6697 17.4334 18.6929 17.5924 15.0784L19.0574 10.9549C18.9882 9.34933 17.8247 9.23664 17.5924 9.23664H13.4394C11.7994 9.23664 10.2519 8.43392 9.3261 7.07852C9.16739 6.85481 8.83674 6.89429 8.73093 7.14431L8.62512 7.39434C8.33414 8.1181 7.77865 8.67079 7.09089 8.98661C7.07105 8.99319 7.0479 9.00306 7.02475 9.01293C7.00161 9.0228 6.97846 9.03267 6.95862 9.03925C6.65442 9.19716 5.94021 9.6709 5.91376 10.8947L5.92698 11.2895L5.94021 11.6316Z",
    fill: "url(#paint9_radial_715_17275)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 19.9658C6.94983 19.9658 2.47266 24.443 2.47266 29.9658V30.0166H22.4727V29.9658C22.4727 24.443 17.9955 19.9658 12.4727 19.9658Z",
    fill: "url(#paint10_linear_715_17275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 19.9658C6.94983 19.9658 2.47266 24.443 2.47266 29.9658V30.0166H22.4727V29.9658C22.4727 24.443 17.9955 19.9658 12.4727 19.9658Z",
    fill: "url(#paint11_radial_715_17275)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 19.9658C6.94983 19.9658 2.47266 24.443 2.47266 29.9658V30.0166H22.4727V29.9658C22.4727 24.443 17.9955 19.9658 12.4727 19.9658Z",
    fill: "url(#paint12_radial_715_17275)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 19.9658C6.94983 19.9658 2.47266 24.443 2.47266 29.9658V30.0166H22.4727V29.9658C22.4727 24.443 17.9955 19.9658 12.4727 19.9658Z",
    fill: "url(#paint13_radial_715_17275)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0352,
    y: 16.9385,
    width: 4.89844,
    height: 6.67969,
    rx: 2.44922,
    fill: "url(#paint14_radial_715_17275)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3496,
    y: 15.7188,
    width: 4.01489,
    height: 2.01643,
    fill: "#F1A31E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1211 13.8057C21.5664 14.4541 21.3802 15.2224 21.3594 15.5635L23.207 15.462L24.0938 14.2784C24.3828 13.8955 24.6328 13.2588 24.0586 12.837C23.5929 12.4948 23.1133 12.7705 22.957 12.9424C22.8945 12.9997 22.7086 13.187 22.1211 13.8057Z",
    fill: "url(#paint15_radial_715_17275)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1211 13.8057C21.5664 14.4541 21.3802 15.2224 21.3594 15.5635L23.207 15.462L24.0938 14.2784C24.3828 13.8955 24.6328 13.2588 24.0586 12.837C23.5929 12.4948 23.1133 12.7705 22.957 12.9424C22.8945 12.9997 22.7086 13.187 22.1211 13.8057Z",
    fill: "url(#paint16_radial_715_17275)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7164 14.1109C29.798 14.5732 29.4894 15.0141 29.0271 15.0957C28.8794 15.1217 28.6888 15.1614 28.4639 15.2083C27.8112 15.3443 26.8705 15.5403 25.8579 15.6361C25.3906 15.6804 24.9758 15.3374 24.9316 14.87C24.8873 14.4027 25.2303 13.9879 25.6977 13.9437C26.607 13.8576 27.3766 13.6971 28.0158 13.5638C28.2758 13.5096 28.5142 13.4599 28.7316 13.4215C29.1939 13.3399 29.6348 13.6486 29.7164 14.1109Z",
    fill: "#FFCA37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7164 14.1109C29.798 14.5732 29.4894 15.0141 29.0271 15.0957C28.8794 15.1217 28.6888 15.1614 28.4639 15.2083C27.8112 15.3443 26.8705 15.5403 25.8579 15.6361C25.3906 15.6804 24.9758 15.3374 24.9316 14.87C24.8873 14.4027 25.2303 13.9879 25.6977 13.9437C26.607 13.8576 27.3766 13.6971 28.0158 13.5638C28.2758 13.5096 28.5142 13.4599 28.7316 13.4215C29.1939 13.3399 29.6348 13.6486 29.7164 14.1109Z",
    fill: "url(#paint17_radial_715_17275)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7164 14.1109C29.798 14.5732 29.4894 15.0141 29.0271 15.0957C28.8794 15.1217 28.6888 15.1614 28.4639 15.2083C27.8112 15.3443 26.8705 15.5403 25.8579 15.6361C25.3906 15.6804 24.9758 15.3374 24.9316 14.87C24.8873 14.4027 25.2303 13.9879 25.6977 13.9437C26.607 13.8576 27.3766 13.6971 28.0158 13.5638C28.2758 13.5096 28.5142 13.4599 28.7316 13.4215C29.1939 13.3399 29.6348 13.6486 29.7164 14.1109Z",
    fill: "url(#paint18_linear_715_17275)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7164 14.1109C29.798 14.5732 29.4894 15.0141 29.0271 15.0957C28.8794 15.1217 28.6888 15.1614 28.4639 15.2083C27.8112 15.3443 26.8705 15.5403 25.8579 15.6361C25.3906 15.6804 24.9758 15.3374 24.9316 14.87C24.8873 14.4027 25.2303 13.9879 25.6977 13.9437C26.607 13.8576 27.3766 13.6971 28.0158 13.5638C28.2758 13.5096 28.5142 13.4599 28.7316 13.4215C29.1939 13.3399 29.6348 13.6486 29.7164 14.1109Z",
    fill: "url(#paint19_radial_715_17275)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2945 14.4392C30.3761 14.9015 30.0675 15.3424 29.6052 15.424C29.4854 15.4452 29.3469 15.4711 29.192 15.5002C28.5298 15.6243 27.5657 15.805 26.4595 15.9097C25.9921 15.954 25.5774 15.611 25.5331 15.1436C25.4889 14.6763 25.8319 14.2616 26.2992 14.2173C27.3195 14.1207 28.1884 13.9582 28.8516 13.8341C29.0174 13.8031 29.1705 13.7745 29.3098 13.7499C29.7721 13.6683 30.213 13.9769 30.2945 14.4392Z",
    fill: "#FFCA37"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2945 14.4392C30.3761 14.9015 30.0675 15.3424 29.6052 15.424C29.4854 15.4452 29.3469 15.4711 29.192 15.5002C28.5298 15.6243 27.5657 15.805 26.4595 15.9097C25.9921 15.954 25.5774 15.611 25.5331 15.1436C25.4889 14.6763 25.8319 14.2616 26.2992 14.2173C27.3195 14.1207 28.1884 13.9582 28.8516 13.8341C29.0174 13.8031 29.1705 13.7745 29.3098 13.7499C29.7721 13.6683 30.213 13.9769 30.2945 14.4392Z",
    fill: "url(#paint20_radial_715_17275)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2945 14.4392C30.3761 14.9015 30.0675 15.3424 29.6052 15.424C29.4854 15.4452 29.3469 15.4711 29.192 15.5002C28.5298 15.6243 27.5657 15.805 26.4595 15.9097C25.9921 15.954 25.5774 15.611 25.5331 15.1436C25.4889 14.6763 25.8319 14.2616 26.2992 14.2173C27.3195 14.1207 28.1884 13.9582 28.8516 13.8341C29.0174 13.8031 29.1705 13.7745 29.3098 13.7499C29.7721 13.6683 30.213 13.9769 30.2945 14.4392Z",
    fill: "url(#paint21_linear_715_17275)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2945 14.4392C30.3761 14.9015 30.0675 15.3424 29.6052 15.424C29.4854 15.4452 29.3469 15.4711 29.192 15.5002C28.5298 15.6243 27.5657 15.805 26.4595 15.9097C25.9921 15.954 25.5774 15.611 25.5331 15.1436C25.4889 14.6763 25.8319 14.2616 26.2992 14.2173C27.3195 14.1207 28.1884 13.9582 28.8516 13.8341C29.0174 13.8031 29.1705 13.7745 29.3098 13.7499C29.7721 13.6683 30.213 13.9769 30.2945 14.4392Z",
    fill: "url(#paint22_radial_715_17275)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.023 14.9968C30.0641 15.4644 29.7183 15.8769 29.2507 15.918C28.9295 15.9462 28.5116 16.0056 27.9904 16.0796L27.9604 16.0839C27.4356 16.1584 26.827 16.2443 26.1736 16.3148C25.7069 16.3651 25.2877 16.0276 25.2374 15.5608C25.1871 15.0941 25.5246 14.6749 25.9914 14.6246C26.613 14.5575 27.1958 14.4754 27.7213 14.4008C27.7428 14.3977 27.7641 14.3947 27.7854 14.3917C28.2765 14.3219 28.7342 14.2568 29.1018 14.2245C29.5694 14.1834 29.9819 14.5292 30.023 14.9968Z",
    fill: "#FFCA37"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.023 14.9968C30.0641 15.4644 29.7183 15.8769 29.2507 15.918C28.9295 15.9462 28.5116 16.0056 27.9904 16.0796L27.9604 16.0839C27.4356 16.1584 26.827 16.2443 26.1736 16.3148C25.7069 16.3651 25.2877 16.0276 25.2374 15.5608C25.1871 15.0941 25.5246 14.6749 25.9914 14.6246C26.613 14.5575 27.1958 14.4754 27.7213 14.4008C27.7428 14.3977 27.7641 14.3947 27.7854 14.3917C28.2765 14.3219 28.7342 14.2568 29.1018 14.2245C29.5694 14.1834 29.9819 14.5292 30.023 14.9968Z",
    fill: "url(#paint23_radial_715_17275)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.023 14.9968C30.0641 15.4644 29.7183 15.8769 29.2507 15.918C28.9295 15.9462 28.5116 16.0056 27.9904 16.0796L27.9604 16.0839C27.4356 16.1584 26.827 16.2443 26.1736 16.3148C25.7069 16.3651 25.2877 16.0276 25.2374 15.5608C25.1871 15.0941 25.5246 14.6749 25.9914 14.6246C26.613 14.5575 27.1958 14.4754 27.7213 14.4008C27.7428 14.3977 27.7641 14.3947 27.7854 14.3917C28.2765 14.3219 28.7342 14.2568 29.1018 14.2245C29.5694 14.1834 29.9819 14.5292 30.023 14.9968Z",
    fill: "url(#paint24_linear_715_17275)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.023 14.9968C30.0641 15.4644 29.7183 15.8769 29.2507 15.918C28.9295 15.9462 28.5116 16.0056 27.9904 16.0796L27.9604 16.0839C27.4356 16.1584 26.827 16.2443 26.1736 16.3148C25.7069 16.3651 25.2877 16.0276 25.2374 15.5608C25.1871 15.0941 25.5246 14.6749 25.9914 14.6246C26.613 14.5575 27.1958 14.4754 27.7213 14.4008C27.7428 14.3977 27.7641 14.3947 27.7854 14.3917C28.2765 14.3219 28.7342 14.2568 29.1018 14.2245C29.5694 14.1834 29.9819 14.5292 30.023 14.9968Z",
    fill: "url(#paint25_radial_715_17275)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0666 17.2654 25.3752 17.1681C25.6179 17.0915 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "#FFCA37"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0666 17.2654 25.3752 17.1681C25.6179 17.0915 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "url(#paint26_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0666 17.2654 25.3752 17.1681C25.6179 17.0915 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "url(#paint27_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0666 17.2654 25.3752 17.1681C25.6179 17.0915 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "url(#paint28_linear_715_17275)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0738 17.324 25.3824 17.2266C25.6251 17.1501 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "url(#paint29_linear_715_17275)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6614 13.9463C25.3327 13.9829 24.8916 14.0319 24.0638 14.1014C23.9888 14.1077 23.9124 14.1137 23.8353 14.1197C22.7757 14.2024 21.5619 14.2972 21.3687 15.4647C21.1697 16.6678 22.552 17.6064 24.2004 17.4189C24.7937 17.3515 25.0738 17.324 25.3824 17.2266C25.6251 17.1501 25.8826 17.008 26.3424 16.9212C27.2588 16.8187 28.1006 16.7143 28.5764 16.6124C29.0219 16.5169 29.3057 16.0783 29.2102 15.6328C29.1148 15.1873 28.6762 14.9035 28.2307 14.999C27.8616 15.0781 27.1777 15.1657 26.3571 15.2589L26.1536 13.8955C25.9928 13.9095 25.8446 13.926 25.6614 13.9463Z",
    fill: "url(#paint30_radial_715_17275)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 17.4775C21.1055 17.3395 21.2174 17.2275 21.3555 17.2275H25.4492C25.5873 17.2275 25.6992 17.3395 25.6992 17.4775V19.1182H21.1055V17.4775Z",
    fill: "url(#paint31_radial_715_17275)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 17.4775C21.1055 17.3395 21.2174 17.2275 21.3555 17.2275H25.4492C25.5873 17.2275 25.6992 17.3395 25.6992 17.4775V19.1182H21.1055V17.4775Z",
    fill: "url(#paint32_linear_715_17275)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.207 18.9729C20.207 18.531 20.5652 18.1729 21.007 18.1729H25.7977C26.2395 18.1729 26.5977 18.531 26.5977 18.9729V30.0166H20.207V18.9729Z",
    fill: "url(#paint33_linear_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.207 18.9729C20.207 18.531 20.5652 18.1729 21.007 18.1729H25.7977C26.2395 18.1729 26.5977 18.531 26.5977 18.9729V30.0166H20.207V18.9729Z",
    fill: "url(#paint34_linear_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.207 18.9729C20.207 18.531 20.5652 18.1729 21.007 18.1729H25.7977C26.2395 18.1729 26.5977 18.531 26.5977 18.9729V30.0166H20.207V18.9729Z",
    fill: "url(#paint35_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.207 18.9729C20.207 18.531 20.5652 18.1729 21.007 18.1729H25.7977C26.2395 18.1729 26.5977 18.531 26.5977 18.9729V30.0166H20.207V18.9729Z",
    fill: "url(#paint36_linear_715_17275)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44055 15.3354C7.58672 15.3354 8.51587 14.4063 8.51587 13.2601C8.51587 12.114 7.58672 11.1848 6.44055 11.1848C5.29439 11.1848 4.36523 12.114 4.36523 13.2601C4.36523 14.4063 5.29439 15.3354 6.44055 15.3354Z",
    fill: "url(#paint37_linear_715_17275)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7101 15.3354C19.8562 15.3354 20.7854 14.4063 20.7854 13.2601C20.7854 12.114 19.8562 11.1848 18.7101 11.1848C17.5639 11.1848 16.6348 12.114 16.6348 13.2601C16.6348 14.4063 17.5639 15.3354 18.7101 15.3354Z",
    fill: "url(#paint38_radial_715_17275)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7115 14.6454C19.4766 14.6454 20.0968 14.0252 20.0968 13.2601C20.0968 12.495 19.4766 11.8748 18.7115 11.8748C17.9464 11.8748 17.3262 12.495 17.3262 13.2601C17.3262 14.0252 17.9464 14.6454 18.7115 14.6454Z",
    fill: "#FFCA38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7115 14.6454C19.4766 14.6454 20.0968 14.0252 20.0968 13.2601C20.0968 12.495 19.4766 11.8748 18.7115 11.8748C17.9464 11.8748 17.3262 12.495 17.3262 13.2601C17.3262 14.0252 17.9464 14.6454 18.7115 14.6454Z",
    fill: "url(#paint39_radial_715_17275)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46541 14.6454C7.23051 14.6454 7.85074 14.0252 7.85074 13.2601C7.85074 12.495 7.23051 11.8748 6.46541 11.8748C5.70031 11.8748 5.08008 12.495 5.08008 13.2601C5.08008 14.0252 5.70031 14.6454 6.46541 14.6454Z",
    fill: "#E28527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46541 14.6454C7.23051 14.6454 7.85074 14.0252 7.85074 13.2601C7.85074 12.495 7.23051 11.8748 6.46541 11.8748C5.70031 11.8748 5.08008 12.495 5.08008 13.2601C5.08008 14.0252 5.70031 14.6454 6.46541 14.6454Z",
    fill: "url(#paint40_radial_715_17275)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint41_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint42_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint43_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint44_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint45_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint46_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint47_radial_715_17275)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92268 11.6317H5.93856L5.92534 11.2896L5.91211 10.8948C5.93856 9.67096 6.65277 9.19722 6.95698 9.03931C6.97681 9.03273 6.99996 9.02286 7.02311 9.01299C7.04625 9.00312 7.0694 8.99326 7.08924 8.98668C7.777 8.67085 8.3325 8.11816 8.62347 7.3944L8.72928 7.14437C8.83509 6.89435 9.16574 6.85487 9.32446 7.07858C10.2503 8.43399 11.7977 9.2367 13.4378 9.2367H17.5908C17.823 9.2367 18.9865 9.34939 19.0558 10.9549L18.9026 14.9184C18.7436 18.5329 15.921 20.96 12.4755 20.96C9.03001 20.96 6.20738 18.5329 6.04836 14.9184L5.92268 11.6317Z",
    fill: "url(#paint48_radial_715_17275)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9781 12.9729L11.0965 15.1655C10.9566 15.6165 11.2923 16.0675 11.7679 16.0675H12.7822C13.2578 16.0675 13.5935 15.6096 13.4536 15.1655L12.7682 12.9729C12.6213 12.4872 12.132 12.4872 11.9781 12.9729Z",
    fill: "#EB8B29"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint49_linear_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint50_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint51_linear_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint52_linear_715_17275)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint53_linear_715_17275)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9909 12.7942L11.3055 14.9868C11.1656 15.4378 11.5013 15.8888 11.9769 15.8888H12.9911C13.4668 15.8888 13.8025 15.4309 13.6626 14.9868L12.9772 12.7942C12.8303 12.3085 12.1448 12.3085 11.9909 12.7942Z",
    fill: "url(#paint54_radial_715_17275)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.675 16.5265L10.675 16.5265L10.6745 16.5263C10.5611 16.4673 10.4432 16.504 10.373 16.5796C10.3028 16.6552 10.276 16.7748 10.3478 16.8811C10.7999 17.5815 11.5875 18.0487 12.485 18.0487C13.3825 18.0487 14.1703 17.5814 14.6223 16.8808C14.6933 16.7718 14.6678 16.6523 14.5966 16.5768C14.526 16.5017 14.4081 16.4677 14.2954 16.5263L14.2954 16.5263L14.2949 16.5265C13.7718 16.8055 13.1553 16.9652 12.485 16.9652C11.8213 16.9652 11.1981 16.8055 10.675 16.5265Z",
    fill: "#8A004F",
    stroke: "url(#paint55_linear_715_17275)",
    strokeWidth: 0.1
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9572 12.5263C14.2995 11.9243 14.8199 11.4487 15.94 11.4487C16.4304 11.4487 16.9033 11.5846 17.3237 11.9243C17.6704 12.2045 17.624 12.5629 17.3555 12.6972L16.6383 13.1066C15.7976 12.8349 14.868 12.7981 13.9572 12.5263Z",
    fill: "#635D5F"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0115 12.5263C10.6692 11.9243 10.1488 11.4487 9.02873 11.4487C8.53831 11.4487 8.06542 11.5846 7.64506 11.9243C7.29835 12.2045 7.34478 12.5629 7.61328 12.6972L8.33044 13.1066C9.17114 12.8349 10.1008 12.7981 11.0115 12.5263Z",
    fill: "#635D5F"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10177 10.967L8.09611 10.9703C8.09596 10.9704 8.09581 10.9704 8.09565 10.9705C7.93194 11.0683 7.71971 11.0152 7.62156 10.8516C7.52327 10.6878 7.57659 10.4752 7.74039 10.377L7.74114 10.3765L7.74247 10.3757L7.74627 10.3735L7.75841 10.3665C7.76849 10.3607 7.78251 10.3528 7.80025 10.3432C7.83571 10.324 7.88617 10.2977 7.94984 10.2674C8.07692 10.2068 8.25807 10.1293 8.47882 10.0588C8.91718 9.9189 9.53019 9.80121 10.1919 9.91799C10.3801 9.95118 10.5056 10.1306 10.4724 10.3187C10.4392 10.5068 10.2598 10.6324 10.0717 10.5992C9.55744 10.5085 9.06361 10.5983 8.68914 10.7178C8.50348 10.7771 8.35171 10.8422 8.24748 10.8919C8.19549 10.9166 8.1557 10.9374 8.12982 10.9514C8.11689 10.9584 8.10747 10.9637 8.10177 10.967Z",
    fill: "#BD4F26"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2979 10.377C17.298 10.377 17.2981 10.3771 17.1202 10.6737L17.2979 10.377C17.4617 10.4752 17.515 10.6878 17.4168 10.8516C17.3186 11.0152 17.1066 11.0684 16.9429 10.9707C16.9428 10.9706 16.9426 10.9705 16.9423 10.9703L16.9365 10.967C16.9308 10.9637 16.9214 10.9584 16.9085 10.9514C16.8826 10.9374 16.8428 10.9166 16.7908 10.8919C16.6866 10.8422 16.5348 10.7771 16.3492 10.7178C15.9747 10.5983 15.4809 10.5085 14.9666 10.5992C14.7785 10.6324 14.5991 10.5068 14.5659 10.3187C14.5327 10.1306 14.6583 9.95118 14.8464 9.91799C15.5081 9.80121 16.1211 9.9189 16.5595 10.0588C16.7802 10.1293 16.9614 10.2068 17.0885 10.2674C17.1521 10.2977 17.2026 10.324 17.2381 10.3432C17.2558 10.3528 17.2698 10.3607 17.2799 10.3665L17.292 10.3735L17.2958 10.3757L17.2972 10.3765L17.2979 10.377Z",
    fill: "#BD4F26"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.569 11.5244C16.4113 11.5244 17.1229 12.1052 17.3165 12.89C17.374 13.1149 17.2014 13.3294 16.9711 13.3294H14.0936C13.9104 13.3294 13.7639 13.162 13.8006 12.9789C13.9628 12.1523 14.69 11.5244 15.569 11.5244Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3008 11.8748C15.9391 11.8748 16.4518 12.3927 16.4518 13.0258C16.4518 13.1304 16.4361 13.2351 16.41 13.3292H14.1864C14.1602 13.2298 14.1445 13.1304 14.1445 13.0258C14.1445 12.3927 14.6625 11.8748 15.3008 11.8748Z",
    fill: "url(#paint56_radial_715_17275)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6426 13.0259C14.6426 12.6597 14.9356 12.3667 15.3018 12.3667C15.668 12.3667 15.961 12.6597 15.961 13.0259C15.961 13.1358 15.9349 13.2404 15.8878 13.3294H14.7211C14.6687 13.2404 14.6426 13.1358 14.6426 13.0259Z",
    fill: "black"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2169 12.1184C15.2988 12.228 15.1275 12.3616 14.9328 12.5072C14.7381 12.6528 14.5936 12.7553 14.5116 12.6457C14.4297 12.5361 14.5212 12.3292 14.7159 12.1836C14.9106 12.038 15.1349 12.0088 15.2169 12.1184Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2169 12.1184C15.2988 12.228 15.1275 12.3616 14.9328 12.5072C14.7381 12.6528 14.5936 12.7553 14.5116 12.6457C14.4297 12.5361 14.5212 12.3292 14.7159 12.1836C14.9106 12.038 15.1349 12.0088 15.2169 12.1184Z",
    fill: "url(#paint57_radial_715_17275)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3264 12.8739C16.2839 12.5765 16.1099 12.3525 16.0283 12.2776L15.6934 12.6452L15.8445 12.9392L16.3264 12.8739Z",
    fill: "url(#paint58_linear_715_17275)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40122 11.5244C8.55887 11.5244 7.84732 12.1052 7.65373 12.89C7.59618 13.1149 7.76884 13.3295 7.99904 13.3295H10.8766C11.0598 13.3295 11.2063 13.162 11.1696 12.9789C11.0074 12.1523 10.275 11.5244 9.40122 11.5244Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66862 11.8748C9.03031 11.8748 8.51758 12.3927 8.51758 13.0258C8.51758 13.1304 8.53327 13.2351 8.55943 13.3293H10.783C10.8092 13.2298 10.8249 13.1304 10.8249 13.0258C10.8197 12.3927 10.3069 11.8748 9.66862 11.8748Z",
    fill: "url(#paint59_radial_715_17275)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3263 13.0259C10.3263 12.6597 10.0333 12.3667 9.66704 12.3667C9.3008 12.3667 9.00781 12.6597 9.00781 13.0259C9.00781 13.1358 9.03397 13.2404 9.08106 13.3294H10.2478C10.2949 13.2404 10.3263 13.1358 10.3263 13.0259Z",
    fill: "black"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7185 12.8901C10.7185 12.5185 10.4162 12.2707 10.3346 12.1958L9.96289 12.5552L10.1916 13.0208L10.7185 12.8901Z",
    fill: "url(#paint60_linear_715_17275)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_715_17275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.32044,
    cy: 12.3667,
    rx: 0.502085,
    ry: 0.254101,
    transform: "rotate(-27.914 9.32044 12.3667)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.32044,
    cy: 12.3667,
    rx: 0.502085,
    ry: 0.254101,
    transform: "rotate(-27.914 9.32044 12.3667)",
    fill: "url(#paint61_radial_715_17275)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9863 10.2C15.4023 10.0988 16.4368 10.1494 17.1283 10.6442",
    stroke: "#C9725D",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0977 10.2C9.68164 10.0988 8.64719 10.1494 7.95569 10.6442",
    stroke: "#C9725D",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17226 5.50379C6.97326 4.7904 8.12867 4.78319 8.77721 4.89849L9.29604 6.56306C8.96456 6.51262 8.66912 6.62792 8.42052 6.86572C7.83252 8.49138 5.81196 9.3878 4.87518 9.63281C4.68062 7.70882 4.78871 6.73601 6.17226 5.50379Z",
    fill: "url(#paint62_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17226 5.50379C6.97326 4.7904 8.12867 4.78319 8.77721 4.89849L9.29604 6.56306C8.96456 6.51262 8.66912 6.62792 8.42052 6.86572C7.83252 8.49138 5.81196 9.3878 4.87518 9.63281C4.68062 7.70882 4.78871 6.73601 6.17226 5.50379Z",
    fill: "url(#paint63_radial_715_17275)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 3.2123C10.2463 2.88978 8.68062 4.44453 8.5293 4.98497C10.5181 9.65444 13.5721 9.20942 16.9603 8.83296C18.9885 8.6076 19.2085 9.53193 19.3815 9.9787C18.8194 4.74717 15.0363 3.94732 11.7071 3.2123Z",
    fill: "url(#paint64_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 3.2123C10.2463 2.88978 8.68062 4.44453 8.5293 4.98497C10.5181 9.65444 13.5721 9.20942 16.9603 8.83296C18.9885 8.6076 19.2085 9.53193 19.3815 9.9787C18.8194 4.74717 15.0363 3.94732 11.7071 3.2123Z",
    fill: "url(#paint65_radial_715_17275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 3.2123C10.2463 2.88978 8.68062 4.44453 8.5293 4.98497C10.5181 9.65444 13.5721 9.20942 16.9603 8.83296C18.9885 8.6076 19.2085 9.53193 19.3815 9.9787C18.8194 4.74717 15.0363 3.94732 11.7071 3.2123Z",
    fill: "url(#paint66_radial_715_17275)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_715_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75586 4.82275C8.78588 5.13621 9.05851 6.31439 9.45844 7.02778",
    stroke: "url(#paint67_linear_715_17275)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_17275",
    x: 2.80078,
    y: 2.01099,
    width: 19.6191,
    height: 19.6196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.537255 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_17275",
    x: 21.3496,
    y: 13.5955,
    width: 7.87891,
    height: 3.84736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.603922 0 0 0 0 0.0941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_715_17275",
    x: 20.207,
    y: 18.1729,
    width: 6.49063,
    height: 11.8438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.337255 0 0 0 0 0.737255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_715_17275",
    x: 4.36523,
    y: 11.1848,
    width: 4.30039,
    height: 4.40063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.627451 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_715_17275",
    x: 16.6348,
    y: 10.9348,
    width: 4.15039,
    height: 4.40063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.341176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_715_17275",
    x: 16.8262,
    y: 11.3748,
    width: 3.77148,
    height: 3.77075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_715_17275",
    x: 4.83008,
    y: 11.6248,
    width: 3.27148,
    height: 3.27075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_715_17275",
    x: 5.91211,
    y: 6.93164,
    width: 13.1445,
    height: 14.4283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.529412 0 0 0 0 0.137255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_715_17275",
    x: 10.5645,
    y: 12.1086,
    width: 3.42188,
    height: 4.45874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_715_17275",
    x: 11.0234,
    y: 12.1799,
    width: 2.92188,
    height: 3.95874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_715_17275",
    x: 13.757,
    y: 11.4487,
    width: 3.81328,
    height: 1.65796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_715_17275",
    x: 7.39844,
    y: 11.4487,
    width: 3.81328,
    height: 1.65796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_715_17275",
    x: 7.57227,
    y: 9.67036,
    width: 3.10625,
    height: 1.34917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_715_17275",
    x: 14.5605,
    y: 9.67036,
    width: 3.10625,
    height: 1.34917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_715_17275",
    x: 14.3824,
    y: 11.952,
    width: 0.955859,
    height: 0.839648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_715_17275",
    x: 15.4934,
    y: 12.0776,
    width: 1.03281,
    height: 1.06162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_715_17275",
    x: 9.76289,
    y: 11.9958,
    width: 1.15586,
    height: 1.22495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_715_17275",
    x: 8.76133,
    y: 11.9415,
    width: 1.11797,
    height: 0.850146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_715_17275",
    x: 14.3871,
    y: 9.55703,
    width: 3.34102,
    height: 1.68721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_715_17275",
    x: 7.35586,
    y: 9.55703,
    width: 3.34102,
    height: 1.68721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_715_17275",
    x: 4.05078,
    y: 4.09326,
    width: 5.99609,
    height: 6.28955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_715_17275",
    x: 8.0293,
    y: 2.6687,
    width: 11.8516,
    height: 7.81006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_715_17275",
    x: 8.45508,
    y: 4.52271,
    width: 1.30273,
    height: 2.80518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_17275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_17275",
    x1: 18.5387,
    y1: 4.29309,
    x2: 9.19923,
    y2: 21.6306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4163 17.5148) rotate(28.3008) scale(4.11372 5.82688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.616274,
    stopColor: "#E38923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E38923",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.59003 15.8829) rotate(90) scale(5.7477 3.4628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9641B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D77117",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4856 16.0023) rotate(90) scale(7.18518 7.48467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.617268,
    stopColor: "#E26B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26B25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.1522 13.6739) rotate(127.617) scale(2.62173 2.54557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161391,
    stopColor: "#C9681C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9681C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.91449 10.5312) rotate(100.537) scale(3.29775 2.66959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.300355,
    stopColor: "#D77016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D77016",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.18212 4.02181) rotate(62.6046) scale(3.07085 5.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221806,
    stopColor: "#C79E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921111,
    stopColor: "#CBA140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5764 5.84957) rotate(132.51) scale(2.11148 2.95076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1704 12.162) rotate(163.779) scale(2.47645 5.38841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD336",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7509 22.1875) rotate(-133.315) scale(6.01301 8.63538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB6325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_17275",
    x1: 12.4727,
    y1: 30.5313,
    x2: 12.4727,
    y2: 24.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172638,
    stopColor: "#9A66F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8757B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4997 29.3751) rotate(-128.9) scale(14.3752 17.7454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195495,
    stopColor: "#9B69F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B69F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8122 18.8751) rotate(80.3112) scale(6.49895 15.3845)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.30201,
    stopColor: "#6B3B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8757B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2311 29.4053) rotate(-120.904) scale(9.57741 5.15543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.269672,
    stopColor: "#6C41BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A68ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9528 19.9376) rotate(60.7594) scale(4.52732 8.4939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23733,
    stopColor: "#DD8031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825613,
    stopColor: "#FFB736"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9136 13.2229) rotate(131.424) scale(2.12546 1.04757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB91D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2261 15.2541) rotate(-70.9274) scale(3.10812 1.58159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854406,
    stopColor: "#EAB23A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB23A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7295 14.0923) rotate(168.638) scale(0.913658 1.16013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_17275",
    x1: 27.8984,
    y1: 15.64,
    x2: 27.5995,
    y2: 14.3862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2846 13.5703) rotate(82.4472) scale(0.334992 2.58545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382314,
    stopColor: "#E4B833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B833",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3077 14.4039) rotate(164.445) scale(0.781591 1.2098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108723,
    stopColor: "#FFDC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_715_17275",
    x1: 28.3196,
    y1: 15.9136,
    x2: 28.1931,
    y2: 14.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21654,
    stopColor: "#E48851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8746 13.8947) rotate(80.4979) scale(0.265417 2.08803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382314,
    stopColor: "#E4B833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B833",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0263 14.8643) rotate(169.282) scale(0.910159 1.09341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_715_17275",
    x1: 28.0318,
    y1: 16.3198,
    x2: 27.9145,
    y2: 15.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21654,
    stopColor: "#E48851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5859 14.3322) rotate(81.4621) scale(0.292302 2.38881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382314,
    stopColor: "#E4B833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B833",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2288 15.6083) rotate(169.423) scale(0.900271 1.06791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.407 15.1447) rotate(81.5732) scale(0.21324 1.76543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.382314,
    stopColor: "#E4B833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B833",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_715_17275",
    x1: 24.6804,
    y1: 16.7697,
    x2: 26.2742,
    y2: 16.4572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.584667,
    stopColor: "#FFCA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_715_17275",
    x1: 27.0632,
    y1: 16.9338,
    x2: 27.0085,
    y2: 16.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10112,
    stopColor: "#E38654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E99344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4148 14.6135) rotate(157.027) scale(3.12266 1.85514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD836",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1948 17.3166) rotate(90) scale(1.05458 3.66708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.440686,
    stopColor: "#8167AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_715_17275",
    x1: 23.574,
    y1: 18.268,
    x2: 23.574,
    y2: 18.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315789,
    stopColor: "#724C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724C80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_715_17275",
    x1: 24.4448,
    y1: 19.3322,
    x2: 24.4448,
    y2: 38.6447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9361E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621359,
    stopColor: "#9661F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_715_17275",
    x1: 27.8585,
    y1: 28.8593,
    x2: 22.4316,
    y2: 28.8593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97AFA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#A97AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97AFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8122 19.1563) rotate(180) scale(2.1875 0.578125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD84F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD84F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_715_17275",
    x1: 23.4023,
    y1: 18.1729,
    x2: 23.4023,
    y2: 19.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365545,
    stopColor: "#946AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#946AD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_715_17275",
    x1: 4.36523,
    y1: 13.3726,
    x2: 8.182,
    y2: 13.3726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6941 13.8265) rotate(-24.444) scale(3.52633 4.30549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.572298,
    stopColor: "#FFC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904617,
    stopColor: "#FFE549"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.409 13.5671) rotate(-20.2976) scale(1.68259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71002,
    stopColor: "#FFBA25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.46541 13.2601) rotate(180) scale(1.38533 1.32516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415002,
    stopColor: "#D67923",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D67923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1717 12.567) rotate(155.244) scale(9.23686 12.3634)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9235"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9348 13.4665) rotate(152.124) scale(3.07822 2.61165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67265 21.3148) rotate(-78.3106) scale(5.3277 6.75986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4883F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4883F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1463 11.9432) rotate(90) scale(9.59649 15.2418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.592664,
    stopColor: "#F3943B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97C39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2932 14.7033) rotate(164.542) scale(7.25623 12.493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.876514,
    stopColor: "#D4993E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4993E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4521 12.0273) rotate(-90) scale(1.48421 1.82152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.01 12.1397) rotate(-90) scale(1.75406 2.01027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09429",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0558 13.9458) rotate(-180) scale(1.73723 5.71902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_715_17275",
    x1: 12.484,
    y1: 15.8888,
    x2: 12.484,
    y2: 12.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C73F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4957 14.8831) rotate(-105.892) scale(3.28511 1.87978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168227,
    stopColor: "#FFE848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE848",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_715_17275",
    x1: 11.1345,
    y1: 14.9056,
    x2: 12.2364,
    y2: 15.0405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A322",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_715_17275",
    x1: 12.484,
    y1: 16.0075,
    x2: 12.484,
    y2: 15.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48538",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_715_17275",
    x1: 12.5849,
    y1: 15.9737,
    x2: 12.5849,
    y2: 15.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2802F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2802F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8548 14.4221) rotate(144.462) scale(2.03121 2.72066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.797297,
    stopColor: "#E2802F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2802F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_715_17275",
    x1: 11.5447,
    y1: 17.9122,
    x2: 12.1284,
    y2: 16.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAC35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2982 12.49) rotate(90) scale(1.04639 1.66441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0047 12.5985) rotate(-127.812) scale(0.4875 0.671171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_715_17275",
    x1: 16.3019,
    y1: 12.5594,
    x2: 15.8976,
    y2: 12.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67124 12.49) rotate(90) scale(1.0464 1.66442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_715_17275",
    x1: 10.6289,
    y1: 12.5593,
    x2: 10.2246,
    y2: 12.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.30098 12.7725) rotate(-90.897) scale(0.636777 0.765432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.98257 4.29319) rotate(129.554) scale(6.92532 3.02034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395696,
    stopColor: "#EE971B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911046,
    stopColor: "#D8772C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.98258 5.50379) rotate(146.397) scale(3.39954 1.68275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120488,
    stopColor: "#FFCA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7957 2.78089) rotate(115.63) scale(6.516 9.25163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.627022,
    stopColor: "#F49523",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49523"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.721 4.39733) rotate(105.909) scale(4.43678 9.2981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131886,
    stopColor: "#FFE337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_715_17275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9681 11.6604) rotate(-117.848) scale(9.43392 8.43334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.897563,
    stopColor: "#CA9B37",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_715_17275",
    x1: 8.75586,
    y1: 5.26592,
    x2: 9.45844,
    y2: 6.90888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6008"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTippinghand);
export default __webpack_public_path__ + "static/media/Tipping hand.339f4a2df38c628f274a52c0fb9099a8.svg";
export { ForwardRef as ReactComponent };